import './OffersAndDealsTopPicks.css';
import React, { useContext, useState, useEffect } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Loader from '../atoms/Loader/Loader';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import { LOCAL_STORAGE_TOPPICKS_NAME } from '../TopPicks/TopPicks';
import { getColorByTheme, getPageThemeColors, get, canUseDOM, hexToRgb, getDictionaryItem } from '../../utils';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import heartLine from '../../resources/icons/heart-line.svg';
import { commonStyles as checkboxesCommon } from '../Listing/Switch';
import { convertToAnalyticObject } from '../../utils/analytics';
import { LOCAL_STORAGE_APP_CURRENCY, TAGS_FOR_PREDEFINED_FACET_NAME } from '../102_ListingOffersAndDeals/constants';
import useProfile from '../../utils/hooks/useProfile';
const CheckBox = _ref => {
  let {
    item,
    index,
    label,
    changeCallback,
    checked
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: item,
    type: "checkbox",
    className: "fp__checkbox",
    id: `oad-toppicks-filter-${TAGS_FOR_PREDEFINED_FACET_NAME}-${index}`,
    name: `oad-toppicks-filter-${TAGS_FOR_PREDEFINED_FACET_NAME}`,
    onChange: () => {
      changeCallback(item);
    },
    checked: checked,
    title: label
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: `oad-toppicks-filter-${TAGS_FOR_PREDEFINED_FACET_NAME}-${index}`
  }, label));
};
const getStorageValues = () => {
  if (canUseDOM) {
    const itemsLS = localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) || null;
    const items = itemsLS ? JSON.parse(itemsLS) : [];
    return get(items, 'list', []).map(item => `objectID:${item && item.itemId && item.itemId.split('-').join('')}`) || [];
  }
  return [];
};
const OffersAndDealsTopPicks = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const userProfile = useProfile();
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const [isVdsite, setIsVdsite] = useState(true);
  const [emptyError, setemptyError] = useState(false);
  const [sendRequest, setSendRequest] = useState(false);
  const [filteringStatements, setFilteringStatements] = useState([]);
  /* const SearchCount: number = get(params, 'SearchCount') || 12; */
  const indexName = get(params, 'SearchIndex');
  const [hits, setHits] = useState();
  /* const [nbHits, setnbHits] = useState<any>(0); */
  /* const [page, setpage] = useState<any>(0); */
  const [facets, setFacets] = useState();
  /* const [result, setResult] = useState<any>(); */
  const [parsedId, setparsedId] = useState('');
  const [overlayButton, setOverlayButton] = useState(false);
  const [timer, settimer] = useState('');
  const [loading, setLoading] = useState(false);
  const [currencyName, setCurrencyName] = useState('');
  const dictionary = get(fields, 'data.dictionary');
  const socialSharing = get(fields, 'data.socialSharing');
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const messageSearchResultEmpty = get(fields, 'data.contextItem.messageSearchResultEmpty.jss.value', '');
  const fromText = getDictionaryItem(dictionary, 'from') || '#';
  const offText = getDictionaryItem(dictionary, 'off') || '#';
  const expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '#';
  const moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '#';
  const bookNowText = getDictionaryItem(dictionary, 'bookNow') || '#';
  const titleText = getDictionaryItem(dictionary, 'title') || '#';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '#';
  const readMoreText = getDictionaryItem(dictionary, 'readMore') || '#';
  const readLessText = getDictionaryItem(dictionary, 'readLess') || '#';
  const errorMessage = getDictionaryItem(dictionary, 'notLikedDeals') || '#';
  const offerAndDealCopy = getDictionaryItem(dictionary, 'offerAndDeal') || '#';
  const removedMessage = getDictionaryItem(dictionary, 'hasBeenRemoved') || '#';
  /* const loadMoreText: string = getDictionaryItem(dictionary, 'loadMore') || '#';
  const viewedAmountText: string = getDictionaryItem(dictionary, 'viewedAmount') || '#'; */
  const ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  const ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';

  /* Params elements */
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  const variables = BackgroundColorHex ? {
    "--offer-and-deal-toppicks-background-color": BackgroundColorHex,
    "--offer-and-deal-toppicks-background-color-rgb": hexToRgb(BackgroundColorHex, true),
    "--offer-and-deal-toppicks-background-active-color": ActiveColorHex,
    "--offer-and-deal-toppicks-color": ColorHex
  } : {
    "--offer-and-deal-toppicks-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--offer-and-deal-toppicks-background-color-rgb": hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    "--offer-and-deal-toppicks-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--offer-and-deal-toppicks-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const RemoveButtonOvelray = () => /*#__PURE__*/React.createElement("div", {
    className: `remove-button-overlay ${overlayButton ? ' remove-button-overlay--active' : ''}`,
    onClick: () => {
      setOverlayButton(false);
      removeItem(parsedId);
      clearTimeout(timer);
    }
  }, `${offerAndDealCopy} ${removedMessage}`);
  const types = ['type:Offer And Deal'];
  const generateStatementsForRequest = () => filteringStatements.map(statement => `${TAGS_FOR_PREDEFINED_FACET_NAME}:${statement}`);

  /* const renderResultsText = () => {
    const loadedHits = (page + 1) * SearchCount;
    return viewedAmountText.replace('{x}', String(loadedHits > nbHits ? nbHits : loadedHits)).replace('{y}', String(nbHits));
  } */

  const removeFav = id => {
    setOverlayButton(false);
    setparsedId(id.split('-').join(''));
    setOverlayButton(true);
    let timer = setTimeout(() => {
      removeItem(id.split('-').join(''));
      setOverlayButton(false);
      clearTimeout(timer);
    }, 2000);
    settimer(timer);
  };
  const removeItem = parsedId => {
    const updatedHits = hits.filter(hit => hit.objectID !== parsedId);
    const objectId = getStorageValues();
    let itemFilters = {
      facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
      facetFilters: [types, [...objectId]]
      /* hitsPerPage: SearchCount, */
    };
    setLoading(true);
    getListing(indexName, itemFilters, algoliaSettings).then(response => {
      setFilteringStatements(Object.keys(get(response, `facets.${TAGS_FOR_PREDEFINED_FACET_NAME}`) || {}));
      setLoading(false);
    }).finally(() => setLoading(false));
    setTimeout(() => {
      if (updatedHits.length === 0) {
        if (filteringStatements) {
          setemptyError(true);
        }
      }
    }, 10);
    setHits(updatedHits);
  };

  /* const loadMore = (): void => {
    setpage((prevState: any) => prevState + 1);
    const objectId = getStorageValues();
      if (objectId.length === 0) {
      setemptyError(true);
      return;
    }
      const filterParams = generateStatementsForRequest();
    const itemFilters = {
      facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
      facetFilters: [types, [...filterParams], [...objectId]],
      hitsPerPage: SearchCount,
      page: page + 1,
    };
      setLoading(true);
    getListing(indexName, itemFilters, algoliaSettings).then((response: any) => {
      setResult(response);
      setnbHits(response.nbHits);
      if (hits) {
        setHits(hits.concat(response.hits));
      } else {
        setHits(response.hits);
      }
      setLoading(false);
    });
  }; */

  useEffect(() => {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(() => {
    const lsCurrency = localStorage.getItem(LOCAL_STORAGE_APP_CURRENCY);
    setCurrencyName(lsCurrency || 'AED');
  }, []);
  useEffect(() => {
    if (sendRequest) {
      setHits([]);
      /* setpage(0); */
      setSendRequest(false);
      const objectId = getStorageValues();
      if (objectId.length === 0) {
        setLoading(false);
        setemptyError(true);
        return;
      }
      const filterParams = generateStatementsForRequest();
      const itemFilters = {
        facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
        facetFilters: [types, [...filterParams], [...objectId]]
        /* hitsPerPage: SearchCount, */
      };
      setLoading(true);
      getListing(indexName, itemFilters, algoliaSettings).then(response => {
        setHits(response.hits);
        /* setnbHits(response.nbHits); */
        /* setResult(response); */
        setLoading(false);
      }).finally(() => setLoading(false));
    }
  }, [sendRequest, filteringStatements]);
  useEffect(() => {
    setLoading(true);
    const objectId = getStorageValues();
    if (objectId.length === 0) {
      setLoading(false);
      setemptyError(true);
      return;
    }
    // let itemFilters: any;

    let itemFilters = {
      facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
      facetFilters: [types, [...objectId]]
      /* hitsPerPage: SearchCount, */
    };
    getListing(indexName, itemFilters, algoliaSettings).then(response => {
      setHits(response.hits);
      /* setnbHits(response.nbHits); */
      /* setResult(response); */
      setFacets(response.facets);
      setFilteringStatements(Object.keys(get(response, `facets.${TAGS_FOR_PREDEFINED_FACET_NAME}`) || {}));
      if (response.hits.length === 0) {
        setemptyError(true);
      }
      setLoading(false);
    }).finally(() => setLoading(false));
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row top-picks",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 offset-xl-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3"
  }, titleText), emptyError && /*#__PURE__*/React.createElement("p", {
    className: "top-picks__desc"
  }, errorMessage.split('##heart##')[0], " ", /*#__PURE__*/React.createElement("img", {
    className: "icon",
    alt: "icon",
    title: "icon",
    src: heartLine
  }), ' ', errorMessage.split('##heart##')[1]), /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll"
  }, facets && facets[TAGS_FOR_PREDEFINED_FACET_NAME] && Object.keys(facets[TAGS_FOR_PREDEFINED_FACET_NAME]).map((facetItemValue, index) => {
    return /*#__PURE__*/React.createElement(CheckBox, {
      item: facetItemValue,
      index: index,
      key: index,
      label: facetItemValue,
      checked: filteringStatements.includes(facetItemValue),
      changeCallback: checkedValue => {
        if (filteringStatements.includes(checkedValue)) {
          //Prevent uncheck all filters
          const newSatements = filteringStatements.filter(statement => statement !== checkedValue);
          if (newSatements.length) {
            setFilteringStatements(newSatements);
            setSendRequest(true);
          }
        } else {
          setFilteringStatements([...filteringStatements, checkedValue]);
          setSendRequest(true);
        }
      }
    });
  })))), loading && /*#__PURE__*/React.createElement(Loader, {
    color: BackgroundColorHex || primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary
  }), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits ? hits.length ? hits.map((hit, index) => /*#__PURE__*/React.createElement("div", {
    className: "OAD-styles col-12 col-sm-6 col-md-4",
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: " OAD-item-col "
  }, /*#__PURE__*/React.createElement(OfferAndDeal, {
    userProfile: userProfile,
    fromText: fromText,
    offText: offText,
    expiresSoonText: expiresSoonText,
    moreInfoText: moreInfoText,
    bookNowText: bookNowText,
    readMoreText: readMoreText,
    readLessText: readLessText,
    termsAndConditionsText: termsAndConditionsText,
    deal: hit,
    rtl: rtl,
    currency: currencyName,
    gridMode: false,
    callback: removeFav,
    useTruncate: false,
    socialSharing: socialSharing,
    themeVariables: variables,
    eventsAnalytics: eventsAnalytics,
    params: params,
    ratingTextStars: ratingTextStars,
    ratingTextStar: ratingTextStar,
    countryItems: countryItems
  })))) : '' : '', !loading && (hits && !hits.length || !hits) && /*#__PURE__*/React.createElement("div", {
    className: "message-search-result-empty"
  }, messageSearchResultEmpty), /*#__PURE__*/React.createElement(RemoveButtonOvelray, null))))));
};
const StyledWrapper = _ref3 => {
  let {
    rtl,
    children,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${checkboxesCommon} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default OffersAndDealsTopPicks;
const commonStyles = "chwtowx";
const ltrStyles = "l19yx90h";
const rtlStyles = "r14rpdc7";